import {
    createContext
} from 'react';

export const POL_THEME = 'POL' as const;

export const MCO_THEME = 'MCO' as const;

export type ThemeName = typeof POL_THEME | typeof MCO_THEME;

// Theme context, see https://reactjs.org/docs/context.html for details
export const ThemeContext = createContext<ThemeName | undefined>(undefined);

export const ANCHOR_POSITIONS = {
    bottom: 'bottom',
    left: 'left',
    right: 'right',
    top: 'top'
} as const;

export type AnchorPosition = (typeof ANCHOR_POSITIONS)[keyof typeof ANCHOR_POSITIONS];

export const COLORS = {
    colorAccent: '#008085',
    colorBondiBlue: '#00a5aa',
    colorSecondary: '#447e83',
    colorSecondaryDark: '#264550',
    colorSidebar: '#f0f0f0',
    default: 'default',
    flat: 'flat',
    gray: 'gray',
    lightgray: 'lightgray',
    outlined: 'outlined',
    outlinedWhite: 'outlinedWhite',
    primary: 'primary',
    secondary: 'secondary',
    white: 'white'
} as const;

export type ColorValue = (typeof COLORS)[keyof typeof COLORS];

export const BACKGROUND_COLORS = {
    vistaWhite: 'vistaWhite',
    white: 'white'
} as const;

export type BackgroundColorValue = (typeof BACKGROUND_COLORS)[keyof typeof BACKGROUND_COLORS];

export const SIZES = {
    large: 'large',
    medium: 'medium',
    small: 'small',
    xlarge: 'xlarge',
    xsmall: 'xsmall',
    xxlarge: 'xxlarge'
} as const;

export type SizeValue = (typeof SIZES)[keyof typeof SIZES];

export const ALIGN = {
    baseline: 'baseline',
    center: 'center',
    end: 'end',
    relative: 'relative',
    right: 'right'
} as const;

export type AlignValue = (typeof ALIGN)[keyof typeof ALIGN];
